<template>
	<div class="data-table-container customize-table">
		<v3-table :headers="headers" :items="itemsToDisplay" alternating :rows-per-page="rowsPerPage" hide-rows-per-page
			hide-footer>
			<template #expand="{
				skills,
				preferredContactTime,
				agentCertificate,
				availableTime,
				remote,
				address,
			}">
				<div>
					<div class="ml-10 mt-2">
						<v-row>
							<v-col cols="2" class="font-weight-medium">
								<div class="mt-2">{{ $t('skillset') }}</div>
								<div class="mt-2">{{ $t('certificate') }}</div>
							</v-col>
							<v-col cols="8">
								<div>
									<v-chip v-for="skill in skills" size="small" class="ml-2" :key="skill.id" :style="{
										'background-color': colorGenerator(
											skill.name
										),
									}">
										<span style="
												color: #fff;
												font-weight: 500;
											">
											{{ skill.name }}
										</span>
									</v-chip>
								</div>
								<div class="mt-2">
									<v-chip v-for="certificate in agentCertificate" size="small" class="ml-2"
										:key="certificate.id" :style="{
											'background-color': colorGenerator(
												certificate.certificateName
											),
										}">
										<span style="
												color: #fff;
												font-weight: 500;
											">
											{{ certificate.certificateName }}
										</span>
									</v-chip>
								</div>
							</v-col>
						</v-row>
					</div>
					<div class="ml-10 mt-2">
						<v-row>
							<v-col cols="3" class="font-weight-medium">
								<div class="mt-2">{{ $t('preferred_contact_time') }}</div>
								<div class="mt-2">{{ $t('available_time') }}</div>
								<div class="mt-2">{{ $t('able_to_work_remotely') }}</div>
								<div class="my-2">
									{{ $t('available_working_location') }}
								</div>
							</v-col>
							<v-col cols="7">
								<div class="mt-2">
									{{ preferredContactTime }}
								</div>
								<div class="mt-2">{{ availableTime }}</div>
								<div class="mt-2">
									{{ remote ? 'Unavailable' : 'Available' }}
								</div>
								<div class="my-2">{{ address }}</div>
							</v-col>
						</v-row>
					</div>
				</div>
			</template>
			<template #item-icon="{ id, active }">
				<div class="d-flex">
					<v-icon style="
							color: grey;
							padding-right: 10px;
							cursor: pointer;
						" @click="editAgent(id)">mdi-pencil</v-icon>
					<v-chip density="default" variant="outlined" class="align-center"
						@click="activeOrInactiveAgent(id, active)">
						{{ active ? $t('Inactive') : $t('Active') }}
					</v-chip>
				</div>
			</template>
			<template #header-active="header">
				<div class="text-left cursor-pointer">
					{{ $t('status') }}
				</div>
			</template>
			<template #header-email="header">
				<div class="text-left cursor-pointer">
					{{ $t('email') }}
				</div>
			</template>
			<template #header-agentDetial="header">
				<div class="text-left cursor-pointer">
					{{ $t('agent_name') }}
				</div>
			</template>
			<template #header-averageRating="header">
				<div class="text-left cursor-pointer">
					{{ $t('rating') }}
				</div>
			</template>
			<template #header-type="header">
				<div class="text-left cursor-pointer">
					{{ $t('type') }}
				</div>
			</template>
			<template #header-phone="header">
				<div class="text-left cursor-pointer">
					{{ $t('phone') }}
				</div>
			</template>

			<template #item-del-icon="{ id, lineName }" v-if="showDelete">
				<v-icon style="color: grey; padding-right: 10px; cursor: pointer"
					@click="deleteAgent(id, lineName)">mdi-trash-can-outline</v-icon>
			</template>
			<template #item-active="{ active }">
				<v-chip :class="active ? 'active-status' : 'inactive-status'" density="default" variant="flat"><v-icon
						start icon="mdi-circle" :class="active
							? 'active-status-icon'
							: 'inactive-status-icon'
							"></v-icon>{{ active ? $t('Active') : $t('Inactive') }}
				</v-chip>
			</template>
			<template #item-averageRating="{ averageRating }">
				<p class="d-flex align-items-center">
					<span v-if="averageRating" class="d-flex align-items-center">
						<span class="mt-1 mr-1">{{
							averageRating.toFixed(1)
						}}</span>
						<v-icon color="orange-lighten-1">mdi-star</v-icon>
					</span>
					<span v-else>-</span>
				</p>
			</template>
			<template #item-agentDetial="{ lineName, firstName, lastName, id }">
				<p style="font-weight: bold; margin-bottom: 1px" @click="goToAgentInformationPage(id)">
					{{ $t('line_name') }} : {{ lineName }}
				</p>
				<p @click="goToAgentInformationPage(id)">
					{{ firstName }} {{ lastName }}
				</p>
			</template>

			<template #item-type="{ UserRoles }">
				<p style="font-weight: bold; margin-bottom: 1px">
					{{ UserRoles[0]?.UserRole?.type === 'general' ? 'IT Service' : UserRoles[0]?.UserRole?.type ===
						'esg' ? 'ESG' : '' }}
				</p>
			</template>

			<template #item-specialization="{ specialization }">
				<!-- <p style="font-family: Roboto; font-weight: 600">
            {{ designation }}
          </p> -->
				<p>{{ specialization }}</p>
			</template>

			<template #item-skills="{ skills }">
				<v-chip v-for="skill in skills" class="ma-1" size="small" :key="skill.id" :style="{
					'background-color': colorGenerator(skill.name),
				}">
					<span style="color: #fff; font-weight: 500">
						{{ skill.name }}
					</span>
				</v-chip>
			</template>
		</v3-table>

		<div class="d-flex flex-row-reverse mx-10">
			<div class="d-flex">
				<div class="my-auto">{{ $t('rows_per_page') }}:</div>
				<v-select variant="underlined" :items="[10, 25, 50, 100]" style="max-width: 4.5rem" class="ml-8 my-auto"
					v-model="totalRowsPerPage" @update:model-value="onClick(totalRowsPerPage)"></v-select>
				<div class="my-auto ml-10">
					{{
						this.initialPage == 1
							? this.initialPage
							: (this.initialPage - 1) * this.totalRowsPerPage + 1
					}}
					- {{ this.initialPage * this.totalRowsPerPage }} of
					{{ this.totalIncidents }}
				</div>
				<div class="my-auto">
					<v-btn :disabled="initialPage == 1" variant="text" @click="previousPage">
						<v-icon size="30">mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn :disabled="items.length < this.totalRowsPerPage" variant="text" @click="nextPage">
						<v-icon size="30">mdi-chevron-right</v-icon>
					</v-btn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue3EasyDataTable from 'vue3-easy-data-table'
import 'vue3-easy-data-table/dist/style.css'
import settings from '@/services/API/settings'

export default {
	async created() {
		await settings.getDefaultPageValue().then((response) => {
			this.totalRowsPerPage = response.data.pageSize
		})
	},
	name: 'DataTable',
	components: {
		'v3-table': Vue3EasyDataTable,
	},
	props: {
		headers: Array,
		items: Array,
		rowsPerPage: {
			type: Number,
			default: 100,
		},
		showDelete: {
			type: Boolean,
			default: true,
		},
	},
	emits: [
		'showAgent',
		'openAgentEditor',
		'openDeleteEditor',
		'openActiveInactiveDialog',
		'totalRowsPerPage',
		'pageNumber',
	],
	methods: {
		previousPage() {
			this.initialPage -= 1

			this.$emit('pageNumber', this.initialPage)
		},
		nextPage() {
			this.initialPage += 1

			this.$emit('pageNumber', this.initialPage)
		},
		onClick(length) {
			this.$emit('totalRowsPerPage', length)
		},
		goToAgentInformationPage(id) {
			this.$router.push(
				`/agent-list/verified-agent/agent-information?agentId=${id}`
			)
		},
		editAgent(id) {
			this.$emit('openAgentEditor', id)
		},
		deleteAgent(id, lineName) {
			this.$emit('openDeleteAgent', {
				id: id,
				lineName: lineName,
			})
		},
		activeOrInactiveAgent(id, active) {
			this.$emit('openActiveInactiveDialog', id, active)
		},
		convertStringToAscii(str) {
			return str
				.split('')
				.map((char) => char.charCodeAt(0))
				.join('')
		},
		colorGenerator(seed) {
			const hex = Math.floor(
				Math.abs(
					Math.sin(this.convertStringToAscii(seed.toLowerCase())) *
					16777215
				)
			).toString(16)

			return `#${hex}`
		},
		updateCurrentPage(page) {
			this.currentPage = page
		},
	},
	data: () => ({
		totalRowsPerPage: '10',
		openCreateDialog: false,
		currentPage: 1,
		colorCode: {
			low: 'gray',
			normal: 'green',
			high: 'yellow',
			urgent: 'red',
		},
		agentDetials: {},
		itemSelected: [],
		initialPage: 1,
		initialRowsPerPage: '10',
		totalIncidents: '100',
	}),
	computed: {
		itemsToDisplay() {
			// Reverse the array to display the latest items at the top
			const reversedItems = [...this.items].reverse()

			const startIndex = (this.currentPage - 1) * this.rowsPerPage
			const endIndex = startIndex + this.rowsPerPage

			// Slice the reversed array
			return reversedItems.slice(startIndex, endIndex)
		},
	},
}
</script>
<style scoped>
.customize-table {
	--easy-table-border: 1px solid var(--primary-color-lighten);
	--easy-table-row-border: 1px solid var(--primary-color-lighten);
	--easy-table-header-font-size: 18px;
	--easy-table-header-height: 50px;
	--easy-table-header-background-color: var(--secondary-color);
	--easy-table-header-item-padding: 15px 20px;
	/* --easy-table-header-font-color: white; */

	--easy-table-body-row-background-color: var(--secondary-color-lighten);
	--easy-table-body-row-height: 50px;
	--easy-table-body-row-font-size: 16px;
	--easy-table-body-row-hover-background-color: var(--primary-color-lighten);

	--easy-table-body-item-padding: 10px 15px;
	--easy-table-footer-background-color: var(--gray-1);
	--easy-table-footer-font-size: 14px;
	--easy-table-footer-padding: 0px 10px;
	--easy-table-footer-height: 50px;

	--easy-table-loading-mask-background-color: #000000;
	font-family: 'Roboto';
}

.active-status {
	background-color: #d3f9dc;
	padding: 10px;
	width: 100px;
	display: flex;
	color: #000;
	justify-content: center;
	font-weight: 500;
}

.active-status-icon {
	color: #12c138;
	font-size: 10px;
}

.inactive-status-icon {
	color: #ff2331;
	font-size: 10px;
}

.inactive-status {
	background-color: #ffc2c6;
	color: black;
	padding: 10px;
	width: 100px;
	text-align: center;
	display: flex;
	justify-content: center;
	font-weight: 500;
}

.link {
	font-weight: 500;
	cursor: pointer;
}
</style>
